// removed by extract-text-webpack-plugin
module.exports = {"timerContainer":"timerContainer__2VOd2","timerImage":"timerImage__1Giaa"};


//////////////////
// WEBPACK FOOTER
// ./components/transaction/src/components/partial/layers/countdownTimer/style.css
// module id = awZB
// module chunks = 459